import React from 'react';
import {Button, Box, Stack, Grid,Typography} from "@mui/material";
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";


const AboutItem = (props) => 
{
    const {i18n } = useTranslation();
    const { t: tBios } = useTranslation('bios');
    const {id} = props;

    let navigate = useNavigate();
const handleClick = (path) =>
    {
       navigate(path);
        window.scrollTo(0, 0);
    }

    return (
        <Grid item lg={3} md={4} xs={6} justifyContent="center"  marginBottom={{lg:"2.5vh",md:"2.5vh", xs:"2.5vh"}}> 
                <Box onClick={()=>handleClick(`/${i18n.language}/bios/${id}`)}  component="img" sx={{height: "auto", display: 'block', width: "95%", overflow: 'hidden'}} src={"/image/bios/"+id+"/thumbnail.webp"} alt={id}/>
                    <Typography textAlign="center" fontWeight="500" color="primary.black" marginTop={{lg:"1vh", md:"2vh", xs:"1vh"}} fontSize={{lg:"25px", md:"30px", xs:"18px"}}>{tBios(id+".name")}</Typography>
            </Grid>



    )
};
export default AboutItem;